import InlineLovesList from 'components/Header/InlineLoves/InlineLovesList/InlineLovesList';
import { withInlineLovesListProps } from 'viewModel/richProfile/myLists/inlineLovesList/withInlineLovesListProps';

export default withInlineLovesListProps(InlineLovesList);
